var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1083",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1083",
    transform: "translate(-940.669 -520.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1136",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1136",
    d: "M988.285,538.27H965.446a1.82,1.82,0,0,0-1.82,1.82V547.4a1.82,1.82,0,0,0,1.82,1.82h12.861a17.166,17.166,0,0,1-7.391,8.66l5.484,9.495a27.456,27.456,0,0,0,14-24.009,18.5,18.5,0,0,0-.316-3.584A1.834,1.834,0,0,0,988.285,538.27Z",
    transform: "translate(6.269 4.957)",
    fill: "#167ee6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1137",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1137",
    d: "M967.859,557.312a17.037,17.037,0,0,1-14.74-8.529l-9.493,5.473a27.975,27.975,0,0,0,38.2,10.277l.028-.018V564.5l-5.491-9.495A16.917,16.917,0,0,1,967.859,557.312Z",
    transform: "translate(0.807 7.824)",
    fill: "#12b347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1138",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1138",
    d: "M976.663,563.18v-.013l-5.484-9.493a16.914,16.914,0,0,1-8.513,2.3v10.954A27.948,27.948,0,0,0,976.663,563.18Z",
    transform: "translate(6.004 9.158)",
    fill: "#0f993e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1139",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1139",
    d: "M951.625,545.091a16.9,16.9,0,0,1,2.3-8.513l-9.493-5.471a27.863,27.863,0,0,0,0,27.969l9.493-5.473A16.9,16.9,0,0,1,951.625,545.091Z",
    transform: "translate(0 3.003)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1140",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1140",
    d: "M967.859,531.053a16.955,16.955,0,0,1,10.819,3.883,1.819,1.819,0,0,0,2.448-.111l5.17-5.17a1.841,1.841,0,0,0-.009-2.6c-.031-.031-.062-.06-.1-.089a27.934,27.934,0,0,0-42.563,7.139l9.493,5.473A17.036,17.036,0,0,1,967.859,531.053Z",
    transform: "translate(0.807)",
    fill: "#ff4b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1141",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1141",
    d: "M973.485,534.936a1.819,1.819,0,0,0,2.448-.111l5.17-5.17a1.841,1.841,0,0,0-.009-2.6c-.031-.031-.062-.06-.1-.089a27.914,27.914,0,0,0-18.331-6.868v10.956A16.955,16.955,0,0,1,973.485,534.936Z",
    transform: "translate(6.005 0)",
    fill: "#d93f21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c0733f4622c1371bf0b5dc8edb7a0cf1.svg";
export { ForwardRef as ReactComponent };